import { render } from "./BalCheckbox.vue?vue&type=template&id=3fa34342"
import script from "./BalCheckbox.vue?vue&type=script&lang=ts"
export * from "./BalCheckbox.vue?vue&type=script&lang=ts"

import "./BalCheckbox.vue?vue&type=style&index=0&id=3fa34342&lang=css"
script.render = render

export default script